import { useReadUserProfile, useLogout } from '@/api/user-manager'
import { InfoItem, PageHeader } from '@/components'
import { Box, Button, Skeleton, Stack } from '@mui/material'
import { PasswordForm } from './password-form'
import { EmailForm } from './email-form'
import { Logout } from '@mui/icons-material'
import { PhoneForm } from './phone-form'

export function AccountPage() {
  const { data: user, isLoading } = useReadUserProfile()

  const { mutateAsync: logout } = useLogout()

  return (
    <>
      <PageHeader>Minha conta</PageHeader>
      {isLoading ? (
        <Loading />
      ) : (
        <Stack spacing={4}>
          <Box mb={4}>
            <InfoItem
              label="Nome"
              value={`${user?.first_name} ${user?.last_name}`}
            />
          </Box>

          <EmailForm />

          <PhoneForm />

          <PasswordForm />

          <Button
            variant="text"
            color="error"
            startIcon={<Logout />}
            onClick={() => logout()}
            sx={{
              visibility: {
                md: 'hidden',
              },
            }}
          >
            Sair da conta
          </Button>
        </Stack>
      )}
    </>
  )
}

const Loading = () => {
  return (
    <Stack spacing={4}>
      <Box mb={4}>
        <Skeleton width={300} />
        <Skeleton width={200} />
      </Box>

      <Box>
        <Skeleton variant="rounded" height={56} sx={{ mb: 2 }} />
        <Skeleton variant="rounded" width={145} height={36} />
      </Box>

      <Box>
        <Skeleton variant="rounded" height={56} sx={{ mb: 2 }} />
        <Skeleton variant="rounded" width={145} height={36} />
      </Box>
    </Stack>
  )
}
